import { Stack } from "@fluentui/react";

const CourseTagsDisplay: React.FunctionComponent<{tags: string[]}> = ({tags}) => {

    return <>
        {tags && tags.filter(t => t && t.length > 0) && <Stack wrap horizontal tokens={{childrenGap: 6}} style={{paddingLeft: 10, paddingRight: 10}}>{tags.filter(t => t && t.length > 0).map((t, i) => {
            return <div key={`tag-${i}`} style={{background: "rgb(0, 120, 212)", borderRadius: 6, padding: 3, color: "white"}}>{t}</div>
        })}
        </Stack>}
    </>
}

export default CourseTagsDisplay;